import $ from 'jquery';
import Swiper, { Navigation } from 'swiper';

function initResourcesSlider() {
  $(function () {
    if ($('.slider-block').length <= 0) {
      return;
    }

    $('.resources-slider').each(function () {
      const sliders = $(this).find('.resources-slider__slider');
      sliders.each(function () {
        const arrows = $(this).find('.slider-arrows');
        const slider = $(this);
        new Swiper(slider.get(0), {
            modules: [Navigation],
            slidesPerView: 1.5, // Default value for large screens
            spaceBetween: 30,
            loop: false,
            navigation: {
                nextEl: slider.find('.swiper-button-next').get(0),
                prevEl: slider.find('.swiper-button-prev').get(0),
            },
            watchOverflow: true, // Automatically hide pagination if all slides fit
            breakpoints: {
            0: {
                slidesPerView: 1.2, // Mobile
            },
            500: {
                slidesPerView: 1.5, // Mobile
            },
            640: {
                slidesPerView: 2.5, // Mobile
                spaceBetween: 40,
            },
            768: {
                slidesPerView: 3, // Tablet
            },
            1024: {
                slidesPerView: 3, // Desktop
            },
            }
        
        });
        });
    });
  });
}

export { initResourcesSlider };
